import React, {useContext} from "react";
import Context from "../../context/Message";

export default ({onClick}) => {
    const {$locale} = useContext(Context);

    return (
        <div className="login-button">
            <span>{$locale.get('auth.login.text')}</span>
            {' '}
            <a className="login-button link-active" onClick={onClick}>{$locale.get('auth.login.button')}</a>
        </div>
    );
}
